import { NameDto } from './NameDto'

export enum CardType {
  Visa = 1,
  Mastercard = 2,
  Maestro = 3,
  AmericanExpress = 4,
  Discover = 5,
  DinersClub = 6,
  UnionPay = 8,
  CartesBancaires = 9,
  Troy = 10,
  BCCard = 11,
  Elo = 12,
  Hiper = 13,
  HiperCard = 14,
  Unknown = 99,
  JCB = 7,
}

export interface CardDetailsDto {
  id?: string
  clientId?: string
  cardHolderName?: string
  cardTokenId: string
  cardNumber: string
  expirationDate: string
  cardType: NameDto<CardType>
  comment?: string
  enabled?: boolean
}

export interface TransactionCardDetailsDto {
  cardNumber: string
  cardType: NameDto<CardType>
  cardHolderName: string
}

export interface CardTokenIdResponseDto {
  tokenId: string
  authentication?: string
}
